import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import './FAQ.scss';
import FAQItem from './FAQItem';
import { IQuestionAnswer } from '../../types/content';
import { adobeTrack } from '../../utils/Functions';
import { ViewAllFAQButtonContainer } from '../UI/Buttons/FAQButton/ViewAllFAQButtonContainer';
import Fade from 'react-reveal/Fade';

interface IFAQProps {
  context?: IContent;
}

const FAQ = ({ context }: IFAQProps) => {
  return (
    <section className="ubisoft-plus_faq">
      <Fade center cascade fraction={0.15}>
        <div className="ubisoft-plus_container">
          <h1 className="dark">{context.faq.title}</h1>
          <div className="accordion_section">
            {context.faq.QuestionAnswer.map(
              (QA: IQuestionAnswer, index: number) => {
                if (QA.question !== '' && QA.answer !== '') {
                  return (
                    <FAQItem key={'QA_' + index} item={QA} trackingText={context.tracking.faq_item_click} />
                  );
                }
              })
            }
          </div>
          <ViewAllFAQButtonContainer content={context.faq.seeFaqButton} redirect={context.faq.cta.redirection}
                                     handleClick={() =>
                                       adobeTrack('clickevent', context.tracking.faq_button_click)
                                     } />
        </div>
      </Fade>
    </section>
  );
};

export default withContent(FAQ);
